import React from "react";
import { Button } from "../../Button";
import { connect } from "react-redux";
import language from "../../../language";
import { fetchSingleWallet } from "../../../queries/wallet/walletQuery";
import { Table } from "../../Table";
import icons from "../../../constants/icons";

class ViewBalance extends React.Component {
  state = {
    data: [],
    page: 0,
    limit: 10,
  };

  componentDidMount = async () => {
    await this.getData(true);
  };

  getData = async (isLoading, search) => {
    const { defaultLanguage, publicId } = this.props;
    const { page, limit } = this.state;
    try {
      this.setState({ isLoading });

      const { content, totalPages } = await fetchSingleWallet(defaultLanguage, {
        publicId,
        page,
        size: limit,
        ...search,
      });

      this.setState({
        data: content,
        isLoading: false,
        totalPageCount: totalPages,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].credit,
        key: "credit",
      },
      {
        title: language[this.props.defaultLanguage].debit,
        key: "debit",
      },
      {
        title: language[this.props.defaultLanguage].description,
        key: "description",
      },
      {
        title: language[this.props.defaultLanguage].source,
        key: "source",
      },
      {
        title: language[this.props.defaultLanguage].transaction_date,
        key: "transactionDate",
      },
    ];

    return headers;
  }
  render() {
    return (
      <>
        <div className="card-body">
          <Table
            data={this.state.data}
            page={this.state.page}
            limit={this.state.limit}
            totalPageCount={this.state.totalPageCount}
            isLoading={this.state.isLoading}
            handlePagination={this.handlePagination.bind(this)}
            headers={this.returnTableHeaders()}
            filters={[
              {
                title: language[this.props.defaultLanguage].date_range,
                button_type: "dropdown",
                icon: icons.calendar,
                filterName: "date",
                handleApply: (date) => this.getData(true, date),
              },
            ]}
          />
        </div>
        <div className="modal-footer">
          <Button
            type="link"
            className="btn-transparent"
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ViewBalance);
